import { Divider, Breadcrumb, Typography, Form, message } from "antd";
import React, { useState } from "react";
import axios from "axios";
import AdminAppLayout from "../../../Layouts/AdminLayout";
import GlobalImageForm from "./form";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { colors } from "../../../utils/colors";
import { dateFormat } from "../../../utils/helpers";
import { ADD_WELCOME_IMAGE, UPDATE_WELCOME_IMAGE } from "../../../../API/paths";
import { RoutesLookup } from "../../../../Routes/RoutesLookup";
import { BASE_URL } from "../../../../Constants/EnvironmentVariableProvider";
import { DATAGRID_DEFAULT_PAGE_SIZE } from "../../../../Constants/ApplicationConstants";

const { Title } = Typography;

const AddNewImage = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const returnPage = queryParams.get("page");
  const returnPageSize = queryParams.get("pageSize");
  const statusType = queryParams.get("statusType");

  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
  
    let startDate = dateFormat(values.start_date, "YYYY-MM-DD");
    let endDate = values.end_date
      ? dateFormat(values.end_date, "YYYY-MM-DD")
      : null;
  
    const isCreateOperation =
      window.location.pathname.includes("/create") || id === "create";
    
    const commonPaginationParams = `?page=${returnPage ?? 1}&pageSize=${
      returnPageSize ?? DATAGRID_DEFAULT_PAGE_SIZE
    }&statusType=${statusType}`;
  
    try {
      if (!isCreateOperation) {
        // Update existing image
        const updateData = {
          GLIM_KeyID: id,
          GLIM_Description: values.description,
          GLIM_Date_From: startDate,
          GLIM_Date_To: endDate,
          GLIM_Image_Path: values.image_path,
          GLIM_Is_Default: values.is_default || false
        };
  
        const response = await axios.put(
          `${BASE_URL}${UPDATE_WELCOME_IMAGE}`,
          updateData
        );
        
        if (response?.data?.success) {
          message.success(response?.data?.message || "Image updated successfully");
          navigate(`${RoutesLookup.SETTINGS}${commonPaginationParams}`);
        } else {
          message.error(response?.data?.errors || "Failed to update image");
        }
      } else {
        // Create new image
        const newImageData = {
          GLIM_Image_Usage_GLIU_KeyID: values.image_usage,
          GLIM_Description: values.description,
          GLIM_Date_From: startDate,
          GLIM_Date_To: endDate,
          GLIM_Image_Path: values.image_path,
          GLIM_Is_Default: values.is_default || false
        };
  
        const response = await axios.post(
          `${BASE_URL}${ADD_WELCOME_IMAGE}`,
          newImageData
        );
        
        if (response?.data?.success) {
          message.success(response?.data?.message || "Image added successfully");
          navigate(`${RoutesLookup.SETTINGS}${commonPaginationParams}`);
        } else {
          message.error(response?.data?.errors || "Failed to add image");
        }
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminAppLayout>
      <div
        style={{
          paddingLeft: 152,
          paddingRight: 152,
          marginTop: 40,
        }}
      >
        <Breadcrumb
          items={[
            {
              title: "Settings",
            },
            {
              title: id !== "create" ? "Edit Global Image" : "New Global Image",
            },
          ]}
        />

        <Title level={4} style={{ color: colors.black, marginTop: 3 }}>
          {id !== "create" ? "Edit Global Image" : "Add New Global Image"}
        </Title>

        <Divider type="horizontal" />

        <div>
          <div style={{ marginBottom: 60 }}>
            <GlobalImageForm
              returnPage={returnPage}
              returnPageSize={returnPageSize}
              statusType={statusType}
              id={id}
              form={form}
              handleSubmit={handleSubmit}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </AdminAppLayout>
  );
};

export default AddNewImage;